export default {
  close: 'Close',
  dataIterator: {
    pageText: '{0}-{1} di {2}',
    noResultsText: 'Nessun risultato trovato',
    loadingText: 'Loading item...',
  },
  dataTable: {
    itemsPerPageText: 'Righe per pagina:',
    ariaLabel: {
      sortDescending: ': Sorted descending. Activate to remove sorting.',
      sortAscending: ': Sorted ascending. Activate to sort descending.',
      sortNone: ': Not sorted. Activate to sort ascending.',
    },
    sortBy: 'Sort by',
  },
  dataFooter: {
    itemsPerPageText: 'Elementi per pagina:',
    itemsPerPageAll: 'Tutti',
    nextPage: 'Pagina seguente',
    prevPage: 'Pagina precedente',
    firstPage: 'Pagina prima',
    lastPage: 'Pagina ultima',
  },
  datePicker: {
    itemsSelected: '{0} selezionati',
  },
  noDataText: 'Nessun elemento disponibile',
  carousel: {
    prev: 'Precedente visivo',
    next: 'Next visual',
  },
  calendar: {
    moreEvents: '{0} di più',
  },
  fileInput: {
    counter: '{0} files',
    counterSize: '{0} files ({1} in total)',
  },
}
